import { Link } from "react-router-dom";
import { ArrowUpRight, Briefcase, Building2, Scissors, Sprout, Trees } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

const ICONS = { Sprout, Building2, Briefcase, Scissors, Trees };
const SPANS = [
  "md:col-span-4",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-2",
];

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="scroll-mt-24 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHead
            overline="O que fazemos"
            title="Serviços de jardinagem, de A a Z"
            text="Do pequeno jardim ao condomínio de grandes dimensões: cuidamos de cada espaço com o mesmo rigor."
          />
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.slug} delay={0.06 * i} className={SPANS[i]}>
                <Link
                  to={`/servicos/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-stone2 bg-white transition-shadow duration-300 hover:shadow-[0_28px_60px_-24px_rgba(18,37,26,0.25)]"
                >
                  <div className={`relative overflow-hidden ${i === 0 ? "h-64 md:h-72" : "h-44"}`}>
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-ivory/90 text-pine backdrop-blur">
                      <Icon size={18} />
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="flex items-start justify-between gap-4">
                      <h3 className="font-serif text-xl text-ink sm:text-2xl">{s.title}</h3>
                      <ArrowUpRight
                        size={20}
                        className="mt-1 shrink-0 text-lime-600 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
                      />
                    </div>
                    <p className="mt-3 text-sm leading-relaxed text-moss">{s.short}</p>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
